import moment from "moment"

// Этапы каскада входа. push — МТС ещё не сообщил канал (Seamless или SIM-Push).
export const STAGES = {
  push: { label: "МТС: Seamless / SIM-Push", short: "Seamless / SIM-Push", color: "geekblue" },
  seamless: { label: "МТС: Seamless", short: "Seamless", color: "blue" },
  sim_push: { label: "МТС: SIM-Push", short: "SIM-Push", color: "cyan" },
  ussd: { label: "МТС: USSD", short: "USSD", color: "purple" },
  sms_otp: { label: "МТС: SMS OTP", short: "SMS OTP", color: "orange" },
  sms: { label: "СМС-код Буше", short: "СМС Буше", color: "gold" },
  none: { label: "Не начат", short: "—", color: "default" },
}

export const STATUSES = {
  success: { label: "Успешно", color: "success" },
  failed: { label: "Неуспешно", color: "error" },
  expired: { label: "Тайм-аут", color: "warning" },
  pending: { label: "В процессе", color: "processing" },
}

export const STEP_STATUSES = {
  success: { label: "Успешно", color: "success" },
  error: { label: "Ошибка", color: "error" },
  timeout: { label: "Тайм-аут", color: "warning" },
  next: { label: "Переход к следующему этапу", color: "default" },
  pending: { label: "В процессе", color: "processing" },
}

// Наши коды ошибок — по-русски; ошибки МТС оставляем как есть, их ищут в документации.
export const ERRORS = {
  retried: "Пользователь запросил вход заново",
  resend_too_early: "СМС не отправлено: рано для повтора, действует прежний код",
  daily_limit: "СМС не отправлено: исчерпан дневной лимит",
  untrusted_smsotp_endpoint: "МТС прислал адрес для кода с недоверенного домена",
  code_attempts_exceeded: "Исчерпаны попытки ввода кода",
  sms_session_expired: "Сессия кода у МТС истекла",
  invalid_id_token: "МТС прислал подтверждение, не прошедшее проверку подписи",
}

export const stageOptions = Object.entries(STAGES)
  .filter(([value]) => value !== "none")
  .map(([value, { label }]) => ({ value, label }))

export const statusOptions = Object.entries(STATUSES).map(([value, { label }]) => ({ value, label }))

export const formatDateTime = (value) => (value ? moment(value).format("DD.MM.YYYY HH:mm:ss") : "—")

export function formatDuration(ms) {
  if (ms === null || ms === undefined) return "—"
  if (ms < 1000) return `${ms} мс`
  if (ms < 60000) return `${(ms / 1000).toLocaleString("ru-RU", { maximumFractionDigits: 1 })} с`

  const minutes = Math.floor(ms / 60000)
  const seconds = Math.round((ms % 60000) / 1000)
  return `${minutes} мин ${seconds} с`
}

export function formatError(error) {
  if (!error) return null
  if (error.startsWith("start_failed")) return `МТС не принял запрос: ${error.replace(/^start_failed:\s*/, "")}`
  return ERRORS[error] ?? error
}
